<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>상담사 캠페인
      <md-button class="md-info md-sm small" @click="closed" v-if="isComp">
        상담사 캠페인 닫기
      </md-button>
    </h3>
    <div class="md-layout">

      <div class="md-layout-item md-size-100 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>캠페인 그룹
            </h4>
            <div style="position: absolute; top: 5px; right: 10px">
              <select name="selectedCampaign" v-model="selectedCampaignInfo" @change="onchangeCampaign">
                <option disabled v-bind:value="{}">캠페인 선택</option>
                <option v-for="item in campaignList" :key="item.CCmpId" v-bind:value="item" :label="item.CCustGrpNm">
                  {{ item }}
                </option>
              </select>
            </div>
          </md-card-header>

          <div class="md-layout-item md-size-100 no-padding">
            <pricing-card :icon-color="this.isCalling ? 'icon-info':'icon-default'">
              <div slot="category" style="padding: 10px;">
                <div class="inline-flex">
                  <input v-focus type="text" style="width: 136px; margin-right: 3px;" v-model="callNumber" v-mask="'#############'">
                  <md-button slot="footer" class="md-sm md-info" @click="callClick" style="min-width: auto; margin-right: 3px;">
                    걸기
                  </md-button>
                  &nbsp;
                  <md-button slot="footer" class="md-sm md-danger" @click="callEndClick" style="min-width: auto;">
                    끊기
                  </md-button>
                </div>
                <div style="display: flex; margin-top: 3px;">
                  <div style="margin-right: 3px;">
                    <select v-model="profile.result" style="margin-bottom: 3px;">
                      <option selected value="">캠페인 대분류 선택</option>
                      <option v-for="item in campaignCd1List" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                    </select>
                    <select v-model="profile.callResult" style="margin-right: 3px;">
                      <option selected value="">캠페인 소분류 선택</option>
                      <option v-for="item in campaignCd2List" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                    </select>
                  </div>
                  <textarea class="h60" v-model="profile.remark" style="margin-right: 3px;"></textarea>
                  <div class="mb10">
                    <md-button slot="footer" class="md-info md-sm full-size-button" @click="saveCampaign">
                      <md-icon>check</md-icon>캠페인 처리
                    </md-button>
                  </div>
                </div>
              </div>
            </pricing-card>
          </div>
          <div>
            <cmp-target-list-comp ref="cmpMemberList" :is-radio="true" :is-calling.sync="isCalling" :hide-perpage-option="true" @returnResult="prepareMember" @returnRes="parseCampaignAnalysis" @onClickPhone="onClickPhone"></cmp-target-list-comp>
          </div>

<!--          <div class="md-group tab-area">-->
<!--            <md-button class="md-default" @click="onClickTab(1)">상세 보기</md-button>-->
<!--            <md-button class="md-default" @click="onClickTab(2)">통계 보기</md-button>-->
<!--          </div>-->
          <div class="simple-tab-group">
<!--            <div v-show="showTab === 1">-->
<!--              &lt;!&ndash; 캠페인 대상 교우 목록 조회 &ndash;&gt;-->
<!--              <cmp-target-list-comp ref="cmpMemberList" :is-radio="true" :is-calling.sync="isCalling" :hide-perpage-option="true" @returnResult="prepareMember" @returnRes="parseCampaignAnalysis" @onClickPhone="onClickPhone"></cmp-target-list-comp>-->
<!--            </div>-->
          </div>
<!--          <div v-show="showTab === 2">-->
<!--            <md-card-content>-->
<!--              <div class="md-layout">-->
<!--                <div class="md-layout-item md-size-50 no-padding">-->
<!--                  <table class="flex-table">-->
<!--                    <tr>-->
<!--                      <th>상태</th>-->
<!--                      <th>최종건수</th>-->
<!--                      <th>처리건수</th>-->
<!--                    </tr>-->
<!--                    <tr v-for="(row, key) in totalResult1Data">-->
<!--                      <td >{{key}}</td>-->
<!--                      <td>{{row.totalCount}}</td>-->
<!--                      <td style="padding: 0;">-->
<!--                        <table style="margin: 0; padding: 0; width: 100%;" cellpadding="0" cellspacing="0" border="0px none">-->
<!--                          <tr v-for="(item, key2) in row.items">-->
<!--                            <td style="border-width: 0; border-right-width: 1px;">{{key2}}</td>-->
<!--                            <td style="border-width: 0;">{{item}}</td>-->
<!--                          </tr>-->
<!--                        </table>-->
<!--                      </td>-->
<!--                    </tr>-->


<!--                  </table>-->
<!--                </div>-->
<!--                <div class="md-layout-item md-size-50 no-padding">-->
<!--                  <table class="flex-table">-->
<!--                    <tr>-->
<!--                      <th>상태</th>-->
<!--                      <th>건수</th>-->
<!--                    </tr>-->

<!--                    <tr-->
<!--                      v-for="item in totalResult2Data"-->
<!--                      :key="item.id"-->
<!--                    >-->
<!--                      <td>{{ item.id }}_{{ item.key }}</td>-->
<!--                      <td>{{ formatter.getCurrency(item.totalCount) }}</td>-->
<!--                    </tr>-->
<!--                  </table>-->
<!--                </div>-->
<!--              </div>-->
<!--            </md-card-content>-->
<!--          </div>-->
        </md-card>
      </div>
    </div>
    <iframe id="iDial" style="display: none;"></iframe>
  </div>
</template>

<script>
import {
  PricingCard,
} from "@/components";
import Swal from "sweetalert2";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import moment from "moment";



import cmpTargetListComp from "@/pages/Counselor/Components/cmpTargetListComp";

export default {
  props: {
    viewMode : {
      type: Number,
      default: 1
    },
    isComp : {
      type: Boolean,
      default: false
    }
  },
  components: {
    PricingCard,
    cmpTargetListComp
  },


  computed: {
    queriedData: {
      get(){
        return this.tableData.slice(this.from, this.to);
      },
      set(value){
        this.tableData = value;
      }
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.page - 1);
    },
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      formatter,

      iDialCallBaseUrl : 'http://127.0.0.1:7070/clickcall?TelNo=',
      iDialCallEndBaseUrl : 'http://127.0.0.1:7070/hangup',

      campaignList : [],
      selectedCampaignInfo : {},

      callNumber : null,

      // 현재 통화중
      isCalling: false,
      // 현재 세팅된 교우 정보
      profile: {},

      campaignCd1List: [],
      campaignCd2List: [],
      showTab: 1,

      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },

      // 1번 탭
      campaignMemberList: [],
      currentMemberIndex: 0,
      isCheckedUncompleted: true,

      // 2번 탭
      totalResult1Data: {},
      totalResult2Data: []
    };
  },

  created() {
    this.getCampaignList();
    this.queryCampaignCd1List();
  },

  methods: {
    closed (){
      this.$emit('update:viewMode', 1);
    },
    getCampaignList(){
      let params = {
        'cAgentId' : (session.get("group") === "3" || session.get("group") === "5")? null: session.get('userNo')
      };
      kuaaApi.sendServer(
        URL_CONST.GET_CMP_PREVIEW,
        params,
        "post",
        response => {
          this.campaignList = response.data.data.contents;
        }
      );

    },

    onchangeCampaign(){
      this.onClickTab(1);
      this.queryCampaignCd2List();
      this.$refs.cmpMemberList.sendQuery(this.selectedCampaignInfo.CCmpId, (session.get("group") === "3" || session.get("group") === "5")? null: session.get('userNo') );
    },

    /**
     * 목록에서 교우를 선택하여 상담 영역으로 옮김
     * @param item
     */
    prepareMember(item) {
	    this.profile = item;
	    this.$emit('memberSelected', item.cCustId);
    },

    /**
     * 상담 대분류 공통코드 조회
     */
    queryCampaignCd1List() {
      kuaaFnc.fncCmpCallTypes(null,res => {
        this.campaignCd1List = res.data.data.contents;
      });
    },

    /**
     * 상담 대분류 공통코드 조회
     */
    queryCampaignCd2List() {
      kuaaFnc.fncCmpMTypes(this.selectedCampaignInfo.calluseCd,null,res => {
        this.campaignCd2List = res.data.data.contents;
      });
    },

    goSeveralManagement() {
      location.href = "/MembershipFee/SeveralManagement/" + this.profile.cCustId;
    },

    onClickCall() {
      this.isCalling = !this.isCalling;
    },

    callClick(){
      let num = kuaaFnc.parseOnlyNum(this.callNumber);
      document.getElementById("iDial").src = this.iDialCallBaseUrl + num;
      // window.open('http://127.0.0.1:7070/clickcall?TelNo=' + num)
    },

    callEndClick(){
      // window.open('http://127.0.0.1:7070/hangup')
      document.getElementById("iDial").src = this.iDialCallEndBaseUrl;
    },



    /**
     * 상담사가 상담처리 버튼을 클릭
     */
    saveCampaign() {
      let modalOptions = kuaaFnc.getSwalModaloptions();
      if(!this.profile.cCustId){
        modalOptions['html'] = '대상 교우를 선택하세요';
        Swal.fire(modalOptions);
        return;
      }
      
      let params = {
        cCmpId : this.profile.cCmpId,
        cCustGrpId : this.profile.cCustGrpId,
        cCustId : this.profile.cCustId,
        cAgentId : this.profile.cAgentId,
        result : this.profile.result,
        callResult : this.profile.callResult,
        startDate : this.profile.startDate,
        remark : this.profile.remark
      }
      
      kuaaApi.sendServer(
        URL_CONST.MODIFY_CMP_RESULT_STATUS_LIST,
        [params],
        "post",
        response => {
          if (response.data.success){
            modalOptions.html = `처리 되었습니다.`;
            Swal.fire(modalOptions);
            this.onClickCall();
            this.$refs.cmpMemberList.sendQuery(this.selectedCampaignInfo.CCmpId);
          } else {
            modalOptions.html = `처리 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      )
    },

    onClickTab(index){
      this.showTab = index;
    },


    parseCampaignAnalysis (list) {
      let now = new Date();
      let tempAnalysisObj1 = {};
      let viewAnalysisObj1 = [];
      let tempAnalysisObj2 = {};
      let viewAnalysisObj2 = [];

      list.forEach((obj)=>{
        /* 통계보기 1 */
        if(!tempAnalysisObj1[obj['resultNm']]){
          tempAnalysisObj1[obj['resultNm']] = {
            id : obj['result'],
            key : obj['resultNm'],
            totalCount : 0,
            cellCount : 0,
            items : {}
          }
        }
        tempAnalysisObj1[obj['resultNm']]['totalCount'] ++;

        if(obj.startDate){
          if(!tempAnalysisObj1[obj['resultNm']]['items'][obj['startDate']]){
            tempAnalysisObj1[obj['resultNm']]['items'][obj['startDate']] = 0;
            tempAnalysisObj1[obj['resultNm']]['cellCount'] ++;
          }
          tempAnalysisObj1[obj['resultNm']]['items'][obj['startDate']] ++;
        }

        /* 통계보기 2 */
        if(!tempAnalysisObj2[obj['callResultNm']]){
          tempAnalysisObj2[obj['callResultNm']] = {
            id : obj['callResult'],
            key : obj['callResultNm'],
            totalCount : 0
          }
        }
        tempAnalysisObj2[obj['callResultNm']]['totalCount'] ++;

      });

      this.totalResult1Data = tempAnalysisObj1; // 통계보기1
      this.totalResult2Data = tempAnalysisObj2; // 통계보기2



    },

    inboundCall(phoneNumber){
      let options = {
        telno: phoneNumber,
        cellular: formatter.getPhoneMask(phoneNumber),
        perPage: 1
      }
      kuaaApi.sendServer(
        URL_CONST.GET_MEMBER_LIST,
        options,
        "post",
        response => {
          let item;
          if (response.data.data.contents.length == 1){
            item = response.data.data.contents[0];
            item['phoneNumber'] = phoneNumber;
          } else {
            item = {
              memberNo: undefined,
              memberHnm: "미확인",
              cellular: phoneNumber,
              phoneNumber : phoneNumber
            }
          }
          this.inboundCallModel(item);
        }
      )
    },

    inboundCallModel(memberInfo) {
      Swal.fire({
        title: "Inbound Call",
        html: `<br><em class="phone-number">${memberInfo.phoneNumber}</em><br>${memberInfo.memberHnm} ${memberInfo.memberNo}님 전화 입니다.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-default",
        confirmButtonText: "전화 받기",
        cancelButtonText: "취소",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$emit('callingCallback', memberInfo);
        }
      });
    },

    onClickPhone (phoneNum){
      let num = this.iDialCallBaseUrl + kuaaFnc.parseOnlyNum(phoneNum);
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "전화 통화를 시도하시겠습니까?",
      });

      setTimeout(function () {
        Swal.fire(modalOptions).then(result => {
          if (result.value) {
            // let url = 'http://127.0.0.1:7070/clickcall?TelNo=' + phoneNum.replace(/-/gi, "");
            // window.open(url, '_blank');
            document.getElementById("iDial").src = num;
          }
        });
      },500)
    }

  }
};
</script>

<style scoped>
.card-footer{
  width: 100%;
}
h2.title{
  font-size: 40px;
  font-weight: 100;
}
p.sub-title{
  color: #999;
  font-size: 20px;
  margin: 20px 0 0 0;
}
p.card-description{
  margin: 5px 0 0 0;
}
.phone-number{
  font-size: 30px;
}
</style>